import React from 'react';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';

const EmptyCardState = ({ readOnly, onClick, className, cardHeading }) => {
    return (
        <div
            onClick={readOnly ? null : onClick}
            className={`h-[136px] flex flex-col items-center justify-center border-2 border-dashed p-3 gap-3 rounded-md border-gray-300 dark:border-[#70707B] bg-[#fafafa] dark:bg-[#FFFFFF0A] sm:p-4 md:p-5 cursor-pointer hover:border-gray-400 ${className}`}>
            <Add data-e2e={cardHeading} className="text-balanceCard-manage !w-8 !h-8" />
            <Typography className="font-semibold text-balanceCard-manage !text-sm uppercase !font-inter">
                {cardHeading}
            </Typography>
        </div>
    );
};

export default EmptyCardState;
